export default function scrollToRef(ref) {
  if (window.scrollY > ref.current.offsetTop) {
    window.scrollTo(0, ref.current.offsetTop);
  }
}
